import styled from "styled-components";

const PassportContainer = styled.div`
  display: inline-block;
  position: relative;
`;

export default PassportContainer;
